import { resolveAvatarType } from '../lib/resolveAvatarType';
export const isType = value => {
  return resolveAvatarType(value) !== undefined;
};
export const isAvatarBorderGradient = value => typeof value === 'object' && value !== null && (value.type === 'linear-gradient' || value.type === 'angular-gradient');